import React, { useEffect, useState } from "react";

import { errorNotification } from "../../../components/toast-notification/common-toast";
import dayjs from "dayjs";
import { getRequest } from "../../../components/axiosClient";
import { useNavigate } from "react-router-dom";
import { Box, Button } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import CommonDatePicker from "../../CommonDatePicker";
import CustomDataGridTable from "../../../components/common/DataGridTable";
import LoadingSpinner from "../../../components/loader/LoadingSpinner";
import {
  GET_REPORT_COMPLETED_TASK,
  GET_REPORT_TRACK,
} from "../../../components/utils";

const Repotemployeecompletedtask = () => {
  // const todayDate = new Date();
  const todayDate = dayjs().format("YYYY-MM-DD");
  const [startDateView, setstartDateView] = useState(todayDate);
  // const [endDateView, setendDateView] = useState(todayDate);

  const [getAlltask, setgetAlltask] = useState(null);
  const [getCompletedTask, setCompletedTask] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  //   const getReportAllEmployeetrack = async () => {
  //     try {
  //       setLoading(true);
  //       let apiUrl = `${GET_REPORT_TRACK}?start_date=${startDateView}`;

  //       // let apiUrl = `${GET_REPORT_TOTAL_TASK}?start_date=${startDateView}&end_date=${endDateView}`;

  //       const res = await getRequest(apiUrl, null, navigate);

  //       if (res.data && res.data.data) {
  //         setgetAlltask(res.data.data);
  //       }

  //       //   if (res.data && res.data.data && Array.isArray(res.data.data.page_data)) {
  //       //     setListAllEmployee(res.data.data.page_data);
  //       //     setPageInformation(res.data.data.page_information);
  //       //   } else {
  //       //     errorNotification(res.errormessage);
  //       //     setListAllEmployee([]);
  //       //   }
  //       setLoading(false);
  //     } catch (error) {
  //       errorNotification(error);
  //       setLoading(false);
  //     }
  //   };
  //   const handleSearch = () => {
  //     getReportAllEmployeetrack();
  //   };
  //   useEffect(() => {
  //     getReportAllEmployeetrack();
  //   }, []);

  const getReportCompletedTask = async () => {
    try {
      setLoading(true);
      let apiUrl = `${GET_REPORT_COMPLETED_TASK}?date=${startDateView}`;

      // let apiUrl = `${GET_REPORT_TOTAL_TASK}?start_date=${startDateView}&end_date=${endDateView}`;

      const res = await getRequest(apiUrl, null, navigate);

      if (res.data && res.data.data) {
        setCompletedTask(res.data.data);
      }

      //   if (res.data && res.data.data && Array.isArray(res.data.data.page_data)) {
      //     setListAllEmployee(res.data.data.page_data);
      //     setPageInformation(res.data.data.page_information);
      //   } else {
      //     errorNotification(res.errormessage);
      //     setListAllEmployee([]);
      //   }
      setLoading(false);
    } catch (error) {
      errorNotification(error);
      setLoading(false);
    }
  };
  const handleCompSearch = () => {
    getReportCompletedTask();
  };
  useEffect(() => {
    getReportCompletedTask();
  }, []);

  const columns = [
    {
      field: "first_name",
      headerName: "First Name",
      width: 150,
    },
    {
      field: "last_name",
      headerName: "Last Name",
      width: 150,
    },
    {
      field: "role",
      headerName: "Role",
      width: 150,
    },
    {
      field: "project_name",
      headerName: "Project Name",
      width: 150,
      // flex: 1,
    },
    {
      field: "task",
      headerName: "Task Title",
      width: 200,
      // resizable: false,
      // width: 120,
      flex: 1,
    },
    // {
    //   field: "api_trackers",
    //   headerName: "Trackers",
    //   width: 150,
    // },
  ];
  //   console.log("getAlltracks", getAlltask);
  console.log("getCompletedTask", getCompletedTask);

  //   const rows = getCompletedTask?.map((data) => ({
  //     id: data.id,
  //     first_name: data.first_name,
  //     last_name: data.last_name,
  //     role: data?.role?.name,
  //     project_name: data?.project_members[0]?.project?.name,
  //     task: data?.project_members[0]?.project?.tasks?.title,
  //     // api_trackers: data?.api_trackers[0]?.api_call_count || "--",
  //   }));

  //   const rows = getCompletedTask?.flatMap((data) =>
  //     data?.project_members?.flatMap((member) =>
  //       member?.project?.tasks?.map((task) => ({
  //         id: data.id,
  //         first_name: data.first_name,
  //         last_name: data.last_name,
  //         role: data?.role?.name,
  //         project_name: member?.project?.name,
  //         task: task?.title, // Mapping all tasks instead of just one
  //       }))
  //     ) || []
  //   );

  const rows = getCompletedTask?.flatMap(
    (data, userIndex) =>
      data?.project_members?.flatMap((member, memberIndex) =>
        (member?.project?.tasks || []).map((task, taskIndex) => ({
          id: `${data.id}-${memberIndex}-${taskIndex}`, // Ensure unique key
          first_name: data.first_name,
          last_name: data.last_name,
          role: data?.role?.name,
          project_name: member?.project?.name,
          task: task?.title || "No Task", // Handle missing tasks
        }))
      ) || []
  );
  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      height={"100%"}
      width={"100%"}
    >
      <Box display={"flex"} gap={2} height={"50px"} alignItems={"center"}>
        <label
          htmlFor="start-date"
          style={{ fontWeight: "bold", marginBottom: "5px" }}
        >
          Date
        </label>
        <CommonDatePicker
          className="common-date-picker"
          placeholder="Select Start Date"
          value={startDateView}
          slotProps={{
            actionBar: {
              actions: ["clear"],
            },
          }}
          onChange={(newDate) =>
            setstartDateView(dayjs(newDate).format("YYYY-MM-DD"))
          }
        />
        {/* <CommonDatePicker
          className="common-date-picker"
          placeholder="Select End Date"
          value={endDateView}
          onChange={(newDate) =>
            setendDateView(dayjs(newDate).format("YYYY-MM-DD"))
          }
        /> */}
        <Button
          variant="contained"
          sx={{
            bgcolor: "#367a7c",
            "&:hover": {
              bgcolor: "#367a7c",
              opacity: 0.8,
            },
            textTransform: "none",
          }}
          onClick={handleCompSearch}
        >
          Search
        </Button>

      </Box>

      <Box flex={1} overflow={"auto"}>
        {loading ? (
          <LoadingSpinner />
        ) : (
          <CustomDataGridTable
            columns={columns}
            rows={rows}
            hideFooter={true}
            rowHeight={30}
            unstable_rowSpanning
            showColumnVerticalBorder
            showCellVerticalBorder
            autoPageSize={true}
            disableColumnMenu={true}
            unstable_strictMode={false}
            sx={{
              "& .MuiDataGrid-cell": {
                display: "flex",
                //   justifyContent: "center", // Center horizontally
                alignItems: "center", // Center vertically
                textAlign: "center",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                textAlign: "center",
                width: "100%",
              },
              "& .MuiDataGrid-cell--rowSpan": {
                display: "flex",
                alignItems: "center", // Ensure row-spanned cells align in the middle
                justifyContent: "center",
                //   height: "20%", // Stretch across the entire row-span height
              },
            }}
          />
        )}
      </Box>
    </Box>
  );
};

export default Repotemployeecompletedtask;
